import { backendApi } from "./axios";
import { PAYMENT_ENDPOINTS, CLASS_PAYMENT_ENDPOINTS } from "./endpoints";

const getSuccessPayments = (payload) => {
  return backendApi.get(PAYMENT_ENDPOINTS.SUCCESS, payload);
};

const getFailedPayments = (payload) => {
  return backendApi.get(PAYMENT_ENDPOINTS.FAILED, payload);
};

const getPendingPayments = (payload) => {
  return backendApi.get(PAYMENT_ENDPOINTS.PENDING, payload);
}

const initiate = (payload) => {
  return backendApi.post(PAYMENT_ENDPOINTS.INITIATE, payload);
};

const tokenize = (payload) => {
  return backendApi.post(PAYMENT_ENDPOINTS.TOKENIZE, payload);
};

const getMyToken = () => {
  return backendApi.get(PAYMENT_ENDPOINTS.MY_TOKEN);
};

/**
 * Handles the POST redirection to PayHere payment gateway.
 * In mock mode (VUE_APP_MOCK_PAYMENTS=true), skips the PayHere redirect entirely:
 * calls the dev mock-notify endpoint to complete the payment, then navigates to return_url.
 */
export const processPayHereRedirect = async (payload, formData) => {
  const backendFields = payload.fields ? payload.fields : payload;
  const finalFields = { ...formData, ...backendFields };

  // [LOCAL DEV] If mock payments enabled, skip redirect and call mock notify endpoint directly to simulate payment completion
  if (process.env.VUE_APP_MOCK_PAYMENTS === 'true') {
    const orderId = finalFields.order_id;
    if (orderId) {
      try {
        await backendApi.post('/payment/dev/mock-notify', { orderId, status: 'success' });
      } catch (err) {
        console.error('[MOCK] mock-notify failed for order', orderId, err);
      }
    }
    const returnUrl = finalFields.return_url;
    if (returnUrl) window.location.href = returnUrl;
    return;
  }

  const action = payload.action || (payload.sandbox ? PAYMENT_ENDPOINTS.PAYHERE_SANDBOX_URL : PAYMENT_ENDPOINTS.PAYHERE_LIVE_URL);

  const submitForm = document.createElement('form');
  submitForm.method = 'POST';
  submitForm.action = action;
  submitForm.style.display = 'none';

  Object.keys(finalFields).forEach((key) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = finalFields[key] ?? '';
    submitForm.appendChild(input);
  });

  document.body.appendChild(submitForm);
  submitForm.submit();
};

const getClassPaymentDetails = (classInstanceId) => {
  return backendApi.get(CLASS_PAYMENT_ENDPOINTS.SESSION_DETAILS.replace(':classInstanceId', classInstanceId));
};

const payForClass = (classInstanceId) => {
  return backendApi.post(CLASS_PAYMENT_ENDPOINTS.PAY, { classInstanceId });
};

const getClassPaymentStatus = (classInstanceId) => {
  return backendApi.get(CLASS_PAYMENT_ENDPOINTS.STATUS.replace(':classInstanceId', classInstanceId));
};

export default { initiate, tokenize, getMyToken, processPayHereRedirect, getSuccessPayments, getFailedPayments, getPendingPayments, getClassPaymentDetails, payForClass, getClassPaymentStatus };
